'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../tslib.es6-fe93d37b.js');
require('react');
require('styled-components');
require('../../_commonjsHelpers-1b94f6bc.js');
require('../../index-c3c373ce.js');
require('../../component.styles-9bb0eef7.js');
var component$C = require('../../component-cb39ed89.js');



exports.ToggleBlock = component$C.ToggleBlock;
